import React, { Component } from 'react';
import {Link} from 'react-router-dom';


function Footer() {

    return (  
    
    <div className="footer">
                    
        <div className="footerElementWrapper">
            <div className='footerElement'>
                <b>sys.team software GmbH</b> <br/>
                Tannenwaldallee 2<br/>
                D-61348 Bad Homburg
            </div>    
            <div className='footerElement'>
                Fon: +49 (0)6172 8557810<br/>
                Fax: +49 (0)6172 8557839<br/>
                E-Mail: info@sys-team.de 
            </div >  
            <div className='footerElement'>
                
                <Link className="footerLink" to="/impressum">Impressum</Link> <br/>
                <Link className="footerLink" to="/about">Datenschutz</Link> 
            </div>  
        </div>
        <div className="copyright">© sys.team software GmbH {new Date().getFullYear()} </div>
    </div>
    
    );

}


export default Footer;